<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.photo.title' | translate"
  [description]="'organizer.photo.title.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="photo.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updatePhoto()"
>
  <app-form-control
    class="block -mt-2"
    [title]="'organizer.edit.photo.content.title' | translate"
  >
    <span custome-label class="sr-only">
      {{ 'organizer.edit.photo.content.label' | translate }}
    </span>

    <app-form-image
      #controlChild
      [formControl]="photo"
      class="flex h-activity-creation-photo"
      [aspectRatio]="imageAspectRatio"
      (change)="checkFormValidity()"
    ></app-form-image>
  </app-form-control>

  <p class="body-sm mb-3">
    {{ 'organizer.edit.photo.example' | translate }}
  </p>

  <p class="mb-3">
    {{ 'organizer.edit.photo.default.description' | translate }}
  </p>

  <button
    app-vtmn-play-button
    type="button"
    [type]="ctaButtonType.Button"
    class="w-full lg:w-auto"
    (click)="useDefaultPhoto()"
  >
    {{ 'organizer.edit.photo.default.button' | translate }}
  </button>

  <app-tips
    #rightColumn
    right-column
    [title]="'organizer.edit.photo.tips.title' | translate"
    [tips]="'organizer.edit.photo.tips.text' | translate"
    [variant]="variantTips"
    [displayArrowIcon]="false"
  ></app-tips>
</app-organizer-shared-layout-edit-field>
